import { BaseBus } from "./BaseBus";
import { CommonFunctions } from "../static/common-functions";

export class OrderBillDetailsBus extends BaseBus
{
    CID(): any {
        return this.orderBillDetailId;
    }
    constructor(data: OrderBillDetailsBus = null) {
        super(data);
    }
    initialize(data: OrderBillDetailsBus) {
        super.initialize(data);
        try {
            this.insertDt = CommonFunctions.getDate(data.insertDt);
            this.updateDt = CommonFunctions.getDate(data.updateDt);
        }
        catch {

        }

    }
    setId(id: any) {
        this.orderBillDetailId = id;
    }
    setParentId(id: any) {
        this.orderBillId = id;
    }
    setFromForm(data: OrderBillDetailsBus) {
        super.setFromForm(data);
        let dateNow = CommonFunctions.getDateNow();
        if (this.hasId) {
            this.updateDt = dateNow;
            this.insertDt = data.insertDt;
            this.insertUserId = data.insertUserId;
        }
        else {
            this.insertDt = dateNow;
            this.insertUserId = data.insertUserId;
        }

    }

    orderBillDetailId: any;
    orderDetailId: any;
    orderBillId: any;
    quantityBilled: number;
    qbid: string;
    qbeditSequenceId: string;
    insertDt: Date;
    insertUserId: any;
    updateDt: Date;
    updateUserid: any;
    orderId: any;
    inventoryId: any;
    quantity: number;
    inventoryNumber: string;
    inventoryDesc: string;
    totalReceived: number;
    price: number;
    toBeReturned: boolean;
    canEditCalc: boolean;
    isPart: boolean;
    dummy: any;
    originalQuantityBilled: number;

}
